// import onceUponATimeSmall from "./paintings-small/once-upon-a-time-small.jpg";
// import onceUponATime from "./paintings/once-upon-a-time.jpg";
// import underTheMilkshakeSmall from "./paintings-small/under-the-milkshake-small.jpg";
// import underTheMilkshake from "./paintings/under-the-milkshake.jpg";
// import vesperSmall from "./paintings-small/vesper-small.jpg";
// import vesper from "./paintings/vesper.jpg";
// import goldenLandscapeSmall from "./paintings-small/golden-landscape-small.jpg";
// import goldenLandscape from "./paintings/golden-landscape.jpg";
// import wrongPlanetSmall from "./paintings-small/wrong-planet-small.jpg";
// import theEnergyOfSpringSmall from "./paintings-small/the-energy-of-spring-small.jpg";
// import theEnergyOfSpring from "./paintings/the-energy-of-spring.jpg";
// import silvermoonSmall from "./paintings-small/silvermoon-small.jpg";
import afternoonSmall from "./paintings-small/afternoon-small.jpg";
import birdcageAndPlumsSmall from "./paintings-small/birdcage-and-plums-small.jpg";
import dreamSmall from "./paintings-small/dream-small.jpg";
import emergingEnergySmall from "./paintings-small/emerging-energy-small.jpg";
import guardianDog1Small from "./paintings-small/guardian-dog-1-small.jpg";
import guardianDog2Small from "./paintings-small/guardian-dog-2-small.jpg";
import onASlowBoatToChinaSmall from "./paintings-small/on-a-slowboat-to-china-small.jpg";
import quackQuackSmall from "./paintings-small/quack-quack-small.jpg";
import storkAndFlowersSmall from "./paintings-small/stork-and-flowers-small.jpg";
import tulipsAndColoursSmall from "./paintings-small/tulips-and-colours-small.jpg";
import underTheJasmineSmall from "./paintings-small/under-the-jasmine-small.jpg";
import afternoon from "./paintings/afternoon.jpg";
import birdcageAndPlums from "./paintings/birdcage-and-plums.jpg";
import dream from "./paintings/dream.jpg";
import emergingEnergy from "./paintings/emerging-energy.jpg";
import guardianDog1 from "./paintings/guardian-dog-1.jpg";
import guardianDog2 from "./paintings/guardian-dog-2.jpg";
import inToTheRed from "./paintings/in-to-the-red.jpg";
import manhood from "./paintings/manhood.jpg";
import onASlowBoatToChina from "./paintings/on-a-slowboat-to-china.jpg";
import quackQuack from "./paintings/quack-quack.jpg";
import silvermoon from "./paintings/silvermoon.jpg";
import storkAndFlowers from "./paintings/stork-and-flowers.jpg";
import tulipsAndColours from "./paintings/tulips-and-colours.jpg";
import underTheJasmine from "./paintings/under-the-jasmine.jpg";
import wrongPlanet from "./paintings/wrong-planet.jpg";

export const paintings = [
  {
    title: "Quack Quack",
    date: "2025",
    size: "60x81",
    imageUrl: quackQuack,
    imageUrlSmall: quackQuackSmall,
  },
  {
    title: "On a Slowboat to China",
    date: "2023",
    size: "80x100",
    imageUrl: onASlowBoatToChina,
    imageUrlSmall: onASlowBoatToChinaSmall,
  },
  {
    title: "Dream",
    date: "2020",
    size: "46x58",
    imageUrl: dream,
    imageUrlSmall: dreamSmall,
  },
  {
    title: "Guardian Dog II",
    date: "2021",
    size: "60x60",
    imageUrl: guardianDog2,
    imageUrlSmall: guardianDog2Small,
  },
  {
    title: "Birdcage and Plums",
    date: "2004-2023",
    size: "63x63",
    imageUrl: birdcageAndPlums,
    imageUrlSmall: birdcageAndPlumsSmall,
    sold: true,
  },
  {
    title: "Tulips and Colours",
    date: "2004-2023",
    size: "63x63",
    imageUrl: tulipsAndColours,
    imageUrlSmall: tulipsAndColoursSmall,
  },
  {
    title: "Under the Jasmine",
    date: "2021",
    size: "60x60",
    imageUrl: underTheJasmine,
    imageUrlSmall: underTheJasmineSmall,
  },
  {
    title: "Stork and Flowers",
    date: "2022",
    size: "60x60",
    imageUrl: storkAndFlowers,
    imageUrlSmall: storkAndFlowersSmall,
  },
  {
    title: "Guardian Dog I",
    date: "2021",
    size: "60x60",
    imageUrl: guardianDog1,
    imageUrlSmall: guardianDog1Small,
  },
  {
    title: "Wrong Planet",
    date: "2025",
    size: "81x65",
    imageUrl: wrongPlanet,
    imageUrlSmall: wrongPlanet,
    sold: true,
  },
  {
    title: "Silvermoon",
    date: "2021",
    size: "130x105",
    imageUrl: silvermoon,
    imageUrlSmall: silvermoon,
  },
  {
    title: "Afternoon",
    date: "2021",
    size: "100x80",
    imageUrl: afternoon,
    imageUrlSmall: afternoonSmall,
    sold: true,
  },
  {
    title: "Emerging Energy",
    date: "2025",
    size: "105x41",
    imageUrl: emergingEnergy,
    imageUrlSmall: emergingEnergySmall,
  },
  {
    title: "In to the Red",
    date: "2025",
    size: "105x41",
    imageUrl: inToTheRed,
    imageUrlSmall: inToTheRed,
  },
  {
    title: "Manhood",
    date: "2025",
    size: "105x41",
    imageUrl: manhood,
    imageUrlSmall: manhood,
  },
];

// {
//   title: "Once Upon a Time",
//   date: "2022",
//   size: "38x56",
//   imageUrlSmall: onceUponATimeSmall,
//   imageUrl: onceUponATime,
// },
// {
//   title: "Under the Milkshake",
//   date: "2022",
//   size: "38x56",
//   imageUrlSmall: underTheMilkshakeSmall,
//   imageUrl: underTheMilkshake,
// },
// {
//   title: "Vesper",
//   date: "2022",
//   size: "40x50",
//   imageUrlSmall: vesperSmall,
//   imageUrl: vesper,
// },
// {
//   title: "Golden Landscape",
//   date: "2020",
//   size: "60x81",
//   imageUrlSmall: goldenLandscapeSmall,
//   imageUrl: goldenLandscape,
// },
// {
//   title: "The Energy of Spring",
//   date: "2022",
//   size: "81x65",
//   imageUrl: theEnergyOfSpring,
//   imageUrlSmall: theEnergyOfSpringSmall,
// },
